import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	SERVICES_FIELD_NAME,
} from '../constants';


export const WhenOtherTextField = ({
	phrases,
	showOther,
}: {
	phrases: Phrases;
	showOther: boolean;
}): React.JSX.Element => {
	const whenLabel = phrases['notificationForm.services.whenField.label'];
	const label = phrases['notificationForm.term.other'];
	return (
		<TextField
			errorSummaryLabel={`${whenLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={SERVICES_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN_OTHER}
			showIf={() => showOther}
		/>
	);
};

